import React from 'react';

/**
 * Paginador reutilizable (arriba o abajo de tablas).
 */
const Paginador = ({
  paginaActual = 1,
  ultimaPagina = 1,
  total = 0,
  registrosPorPagina = 8,
  cargando = false,
  enBusqueda = false,
  onIrAPagina,
  className = ''
}) => {
  if (total === 0 && !cargando) {
    return null;
  }

  const desde = total === 0 ? 0 : (paginaActual - 1) * registrosPorPagina + 1;
  const hasta = Math.min(paginaActual * registrosPorPagina, total);

  const paginas = [];
  const maxBotones = 5;
  let inicio = Math.max(1, paginaActual - Math.floor(maxBotones / 2));
  let fin = Math.min(ultimaPagina, inicio + maxBotones - 1);
  inicio = Math.max(1, fin - maxBotones + 1);
  for (let i = inicio; i <= fin; i++) {
    paginas.push(i);
  }

  const btnStyle = (activo) => ({
    minWidth: '40px',
    padding: '8px 12px',
    borderRadius: '8px',
    border: activo ? 'none' : '1px solid #e0e0e0',
    background: activo
      ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      : '#fff',
    color: activo ? '#fff' : '#495057',
    fontWeight: activo ? 600 : 500,
    cursor: activo || cargando ? 'default' : 'pointer',
    transition: 'all 0.2s ease'
  });

  const ir = (n) => {
    if (!cargando && typeof onIrAPagina === 'function') {
      onIrAPagina(n);
    }
  };

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        padding: '16px 20px',
        background: '#f8f9fa',
        borderRadius: '12px',
        border: '1px solid #e5e7eb'
      }}
    >
      <span style={{ fontSize: '14px', color: '#6b7280' }}>
        Mostrando {desde}–{hasta} de {total}
        {enBusqueda ? ' (búsqueda)' : ''}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
        <button
          type="button"
          className="btn btn-sm"
          style={btnStyle(false)}
          disabled={paginaActual <= 1 || cargando}
          onClick={() => ir(paginaActual - 1)}
        >
          <i className="fas fa-chevron-left" />
        </button>
        {inicio > 1 && (
          <>
            <button type="button" className="btn btn-sm" style={btnStyle(false)} disabled={cargando} onClick={() => ir(1)}>1</button>
            {inicio > 2 && <span style={{ color: '#9ca3af', padding: '0 4px' }}>…</span>}
          </>
        )}
        {paginas.map((num) => (
          <button
            key={num}
            type="button"
            className="btn btn-sm"
            style={btnStyle(num === paginaActual)}
            disabled={num === paginaActual || cargando}
            onClick={() => ir(num)}
          >
            {num}
          </button>
        ))}
        {fin < ultimaPagina && (
          <>
            {fin < ultimaPagina - 1 && <span style={{ color: '#9ca3af', padding: '0 4px' }}>…</span>}
            <button type="button" className="btn btn-sm" style={btnStyle(false)} disabled={cargando} onClick={() => ir(ultimaPagina)}>{ultimaPagina}</button>
          </>
        )}
        <button
          type="button"
          className="btn btn-sm"
          style={btnStyle(false)}
          disabled={paginaActual >= ultimaPagina || cargando}
          onClick={() => ir(paginaActual + 1)}
        >
          <i className="fas fa-chevron-right" />
        </button>
      </div>
    </div>
  );
};

export default Paginador;
